import Api from "@/services/Api";

const state = {
	all_campaigns: [],
	overview: {},
	events: [],
	countrywisestats: [],
	sendingStats: {}
};
const getters = {
	all_campaigns: state => state.all_campaigns,
	overview: state => {
		return state.overview;
	},
	getEvents: state => {
		return state.events;
	},
	countrywisestats: state => state.countrywisestats,
	sendingStats: state => state.sendingStats,
	pieChartData: state => {
		let statedata = state.overview;
		return [
			statedata.clicked,
			statedata.opened,
			statedata.bounced,
			statedata.sent,
			statedata.unsubscribed
		];
	}
};

const actions = {
	GET_OVERVIEW({ commit }, payload) {
		Api.get(`/campaign/${payload}`)
			.then(resp => {
				commit("SET_OVERVIEW", resp.data.data);
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	GET_SENDING_STATS({ commit }, payload) {
		Api.get(`/reports/emails-sent/${payload}`)
			.then(resp => {
				commit("SET_CAMPAIGN_STATS", resp.data.data);
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	GET_COUNTRY_WISE({ commit }, payload) {
		Api.get(`/reports/emails/by-country/${payload}`)
			.then(resp => {
				commit("SET_COUNTRY_REPORT", resp.data.data);
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	ALL_EVENTS_LOGS({ commit }, { page, status, site, context }) {
		if (status === 'all' || status === '' || !status) {
			commit("COMMIT_EVENTS_LOGS", {
				url: `site=${site}&page=${page}`,
				context: context
			});
		} else {
			commit("COMMIT_EVENTS_LOGS", {
				url: `site=${site}&status=${status}&page=${page}`,
				context: context
			});
		}
	},
	GET_ALL_CAMPAIGNS({ commit }, payload) {
		commit("GET_ALL_CAMPAIGNS", payload);
	},
};

const mutations = {
	SET_OVERVIEW(state, data) {
		state.overview = data;
	},
	COMMIT_EVENTS_LOGS(state, payload) {
		Api.get(`event-logs?${payload.url}`)
			.then(resp => {
				state.events = resp.data;
				payload.context.loading = false
			})
			.catch(err => {
				payload.context.loading = false
				return err.response.data.message;
			});
	},
	SET_COUNTRY_REPORT(state, data) {
		state.countrywisestats = data;
	},
	SET_CAMPAIGN_STATS(state, data) {
		state.sendingStats = data;
	},
	GET_ALL_CAMPAIGNS(state, payload) {
		let url = '/admin/campaigns';

		if (payload.query) {
			// Filter all falsy values ( "", 0, false, null, undefined )
			payload.query = Object.entries(payload.query).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {})
			const params = new URLSearchParams(payload.query).toString();
			url = `/admin/campaigns?${params}`;
		}

		payload.context.loading = true;
		Api.get(url)
			.then(resp => {
				payload.context.loading = false;
				state.all_campaigns = resp.data;
			})
			.catch(err => {
				payload.context.loading = false;
				return err.response.data.message;
			});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
